export const modelMetadataSymbol = Symbol("modelMetadata")
export const modelUnwrappedClassSymbol = Symbol("modelUnwrappedClass")
